import { createReducer, on } from '@ngrx/store';
import { EntitlementsState, CurrentUsageFeaturesPlan } from '../types/entitlements.types';
import * as EntitlementsActions from '../actions/entitlements.actions';

export const initialState: EntitlementsState = {
  currentUsageFeaturesPlan: {},
  subscription: null,
  loading: false,
  subscriptionActionLoading: false,
  error: null,
};

export const entitlementsReducer = createReducer(
  initialState,
  on(EntitlementsActions.loadEntitlements, state => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(EntitlementsActions.loadEntitlementsSuccess, (state, { entitlements }) => {
    const currentUsageFeaturesPlan: CurrentUsageFeaturesPlan = {};

    entitlements.data.entitlements.currentUsage.forEach(element => {
      currentUsageFeaturesPlan[element.featureName] = {
        limit: element.limit,
        used: element.used,
      };
    });

    return {
      ...state,
      currentUsageFeaturesPlan,
      subscription: entitlements.data.subscription,
      loading: false,
      error: null,
    };
  }),
  on(EntitlementsActions.loadEntitlementsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(EntitlementsActions.setCurrentUsageFeaturesPlan, (state, { currentUsageFeaturesPlan }) => ({
    ...state,
    currentUsageFeaturesPlan,
  })),
  on(EntitlementsActions.clearEntitlementsError, state => ({
    ...state,
    error: null,
  })),
  on(EntitlementsActions.scheduleCancelSubscription, state => ({
    ...state,
    subscriptionActionLoading: true,
    error: null,
  })),
  on(EntitlementsActions.scheduleCancelSubscriptionSuccess, (state, { subscription }) => ({
    ...state,
    subscription,
    subscriptionActionLoading: false,
    error: null,
  })),
  on(EntitlementsActions.scheduleCancelSubscriptionFailure, (state, { error }) => ({
    ...state,
    subscriptionActionLoading: false,
    error,
  })),
  on(EntitlementsActions.reactivateSubscription, state => ({
    ...state,
    subscriptionActionLoading: true,
    error: null,
  })),
  on(EntitlementsActions.reactivateSubscriptionSuccess, (state, { subscription }) => ({
    ...state,
    subscription,
    subscriptionActionLoading: false,
    error: null,
  })),
  on(EntitlementsActions.reactivateSubscriptionFailure, (state, { error }) => ({
    ...state,
    subscriptionActionLoading: false,
    error,
  }))
);
